import { Box } from "@mui/material";

/**
 * Route/chunk fallback — no spinner; fills content area with theme background.
 * Header API loader (GenericHeader) handles fetch/save states.
 */
const PageLoader = () => (
  <Box
    aria-busy="true"
    aria-label="Loading page"
    sx={{
      flex: 1,
      width: "100%",
      minHeight: "100%",
      bgcolor: "background.default",
    }}
  />
);

export default PageLoader;
